import React from 'react';
import { Accordion, AccordionItem, AccordionHeader, AccordionBody } from '../accordion';
import { is } from '../../services/index';
import { Text, TextLevels } from '../text';
import clsx from 'clsx';
import { hashClass } from '../../helpers';
import { TypographyBold } from '../../objects';
import { useTrilogyContext } from '../../context';
/**
 * Disclaimer component
 * @param children {React.ReactNode|string} Disclaimer Item Children
 * @param className {string} Additionnal css classes
 * @param title {string} Disclaimer Title
 * @param active {boolean} Active Disclaimer Bar
 */
const Disclaimer = ({ children, className, title, active, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = clsx('disclaimer', is('tri'), className);
    const wrapperClasses = clsx('disclaimer-header', is('grouped'), is('tri'));
    const classesBody = clsx('accordion-body', is('clipped'), is('tri'));
    const classesContent = hashClass(styled, clsx('disclaimer-content', active && is('active'), 'subtitle', is('tri')));
    return (React.createElement(Accordion, { className: classes, ...others },
        React.createElement(AccordionItem, null,
            React.createElement(AccordionHeader, { className: wrapperClasses, toggleBox: 'left', toggleBoxClass: is('bordered') },
                React.createElement(Text, { level: TextLevels.TWO, typo: TypographyBold.TEXT_WEIGHT_SEMIBOLD }, title)),
            React.createElement(AccordionBody, { className: classesBody },
                React.createElement("div", { className: classesContent }, children && typeof children.valueOf() === 'string' ? React.createElement(Text, null, String(children)) : children)))));
};
export default Disclaimer;
//# sourceMappingURL=Disclaimer.js.map